import { render, staticRenderFns } from "./edit-travel-policy-form.vue?vue&type=template&id=ae7f5384&scoped=true&"
import script from "./edit-travel-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-travel-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f5384",
  null
  
)

export default component.exports